<template>
    <CardPage :section="6" :page="11" next="/" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            Great work! I hope you can put some of these strategies to work the next time you are feeling angry or overwhelmed. You’ve earned another sticker
            for completing this activity.
        </p>
        <ResponsiveImage :src="sticker.image" :alt="sticker.text"></ResponsiveImage>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        sticker: get('section6/sticker')
    },
    methods: {
        finish() {
            this.$store.set('section6/complete', true);
            this.$store.set('section6/sticker@earned', true);
        }
    }
};
</script>
